/**
 * @file Keep all host names in one place.
 */
export const US_INHOUSE_HOST = 'v1.padlet.pics'
export const US_PROXY_HOST = 'padlet.pics'
export const EU_INHOUSE_HOST = 'v1-eu.padlet.pics'
export const EU_PROXY_HOST = 'eu.padlet.pics'
export const GOOGLE_HOST = 'g4.padlet.pics'
export const BUNNY_GOOGLE_PROXY_HOST = 'g4.padlet.pics'

// current and former inhouse hosts
export const INHOUSE_HOST_LIST = [
  US_INHOUSE_HOST,
  EU_INHOUSE_HOST,
  US_PROXY_HOST,
  EU_PROXY_HOST,
  'imgglb.padletcdn.com',
]
